<template>
    <div v-if="is_html" v-html="src" :class="classnames" :style="'width:'+width+';height:'+ height" @click="click"></div>
    <inline-svg :class="classnames" v-else :src="path" :width="width" :height="height" @click="click" />
</template>
  
  <script>
  
  import InlineSvg from 'vue-inline-svg';

  export default {
      name: "DSVG",
      props:["src", "width", "height", "class"],
      components:{
        InlineSvg
      },
      computed: {
          path(){
              const url = '' + this.src;
              return url;
          },
          is_html(){
              return this.src.includes("<svg");
          },
          classnames(){
              return this.class ?? "";
          },
      },
      methods:{
          click(event){
              this.$emit("click", event);
          }
      }
  }
  </script>
  